import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './ideiaNegocioForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import imagemFundo from '../assets/images/ideiaNegocio/fundo.png';

import { setModoTela, initForm, salvar, excluir, getLista } from './ideiaNegocioActions';
import { getLista as getListaTexto } from '../texto/textoActions';
import TextoInput from '../texto/textoInput';

class IdeiaNegocio extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTexto();
    }

    render() {
        return (
            <Background
				imagem={imagemFundo}
				backgroundPosition={'bottom 100px'}
				gradientStart='#0F2748'
				gradientEnd='#0F2748'>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'visualizacao' ? (
						<Form visualizacao onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </Background>
        )
    }

	lista() {

		let lista = this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<>
				<Row alignCenter>
					<Grid cols='12 10 8 6'>
						<ContentCard
							style={{
								marginTop: 20,
								backgroundColor: '#0F2748',
								color: '#ffffff',
								borderRadius: 20,
								boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
								opacity: '80%'
							}}>
							<ContentCardBody>
								<Row alignCenter 
									style={{ 
										padding: 16
									}}>
									<Grid cols='12 12 12 12'>
										<h3 style={{ textAlign: 'center' }}>{this.props.ideiaNegocioTitulo}</h3>
										
										<TextoInput chave='ideiaNegocioTitulo' />
									</Grid>
									<Grid cols='12 12 12 12' style={{ padding: 16 }}>
										<p style={{ textAlign: 'center' }}>{this.props.ideiaNegocioDescricao}</p>

										<TextoInput chave='ideiaNegocioDescricao' />
									</Grid>
									<Grid cols='12 10 6 4'>
										<Button
											text='Clique Aqui'
											type={'primary'}
											icon={'fa fa-plus'}
											event={() => {
												this.props.setModoTela('cadastro', {});
												this.props.initForm({});
											}} />
									</Grid>
								</Row>
							</ContentCardBody>
						</ContentCard>
					</Grid>
				</Row>

				{lista.length > 0 &&
				<Row>
					<Grid cols='12 12 12 12'>
						<div style={{ textAlign: 'center', fontWeight: 'bold', color: '#19CCCC', fontSize: 22, marginBottom: 10 }}>IDEIAS ENVIADAS</div>
					</Grid>
				</Row>}
				
				{lista.map(item => (
					<Row alignCenter>
						<Grid cols='12 10 8 6'>
							<ContentCard
								style={{
									marginTop: 20,
									backgroundColor: '#0F2748',
									color: '#ffffff',
									borderRadius: 20,
									boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
									opacity: '80%'
								}}>
								<ContentCardBody>
									<Row alignCenter 
										style={{ 
											padding: 16
										}}>
										<Grid cols='12 12 12 12'>
											<p style={{ textAlign: 'center', fontWeight: 'bold' }}>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</p>
										</Grid>
										<Grid cols='12 12 12 12' style={{ padding: 16 }}>
											<p style={{ textAlign: 'center' }}>{item.nome_projeto}</p>
										</Grid>
										<Grid cols='12 10 6 4'>
											<Button
												text='Visualizar'
												type={'primary'}
												icon={'fa fa-plus'}
												event={() => {
													this.props.setModoTela('visualizacao', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />
										</Grid>
									</Row>
								</ContentCardBody>
							</ContentCard>
						</Grid>
					</Row>
				))}
			</>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.ideiaNegocio.modoTela,
	aguardando: state.ideiaNegocio.aguardando,
	lista: state.ideiaNegocio.lista.filter(item => item.id_usuario == state.auth.usuario.id),
	ideiaNegocioTitulo: state.texto.lista.filter(item => item.chave == 'ideiaNegocioTitulo').map(item => item.valor)[0],
	ideiaNegocioDescricao: state.texto.lista.filter(item => item.chave == 'ideiaNegocioDescricao').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista,
	getListaTexto
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IdeiaNegocio);
